"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const react_1 = __importDefault(require("react"));
const Paths_1 = require("../../shared/Icons/Paths");
const tokens_1 = require("../../styles/tokens");
const types_1 = require("../../styles/types");
const Icon_styles_1 = require("./Icon.styles");
const isColourPrimaryVariant = (colour) => {
    return types_1.IconPrimaryColours.some((c) => c === colour);
};
const isColourGreyscaleVariant = (colour) => {
    return types_1.IconGreyscaleColours.some((c) => c === colour);
};
const getHaloColour = (colour, luminosity) => {
    const isHighLum = luminosity === "high";
    if (colour === "greyscale") {
        return isHighLum ? tokens_1.COLOURS.greyscale.silver : tokens_1.COLOURS.greyscale.zinc;
    }
    else {
        return isHighLum
            ? tokens_1.COLOURS.primary[colour][25]
            : tokens_1.COLOURS.primary[colour][100];
    }
};
const Halo = ({ colour, luminosity = "high" }) => {
    return (react_1.default.createElement("circle", { cx: "25", cy: "25", r: "25", fill: getHaloColour(colour, luminosity) }));
};
/**
 * @deprecated please use <Ds.Icon /> or <Ds.Halo /> instead
 */
const Icon = ({ size = 5, style = "Line", theme, // TODO: We can't set "Line" by default for now, but add it back once we kill style props
name = "Tick", colour = "zinc", rotation = "down", props, halo, title, id, }) => {
    let iconColour;
    if (!(name in Paths_1.paths[theme || style])) {
        console.error(`Icon with name ${name} does not exist in ${theme || style} style. Please change the style prop to "${theme || style === "Line" ? "Fill" : "Line"}".`);
        return null;
    }
    if (isColourPrimaryVariant(colour)) {
        iconColour = tokens_1.COLOURS.primary[colour][100];
    }
    else if (isColourGreyscaleVariant(colour)) {
        iconColour = tokens_1.COLOURS.greyscale[colour];
    }
    if (!!halo) {
        // Overwrite the icon colour if a halo to ensure decent contrast
        iconColour =
            halo.luminosity === "low"
                ? tokens_1.COLOURS.greyscale.white
                : tokens_1.COLOURS.greyscale.zinc;
    }
    const Path = Paths_1.paths[theme || style][name];
    return (react_1.default.createElement(Icon_styles_1.StyledIcon, Object.assign({ size: size, rotation: rotation, viewBox: !!halo ? "0 0 50 50" : "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", "aria-label": title, "aria-hidden": !title, role: "img" }, props),
        !!halo && (react_1.default.createElement(Halo, { colour: halo.colour, luminosity: halo.luminosity })),
        react_1.default.createElement("g", { transform: !!halo ? "translate(5 5)" : "" },
            react_1.default.createElement(Path, { colour: iconColour }))));
};
exports.Icon = Icon;
Icon.displayName = "Icon";
//# sourceMappingURL=Icon.js.map